import React, {Component} from "react";
import {withPixiApp} from "@inlet/react-pixi";
import {connect} from "react-redux";
import {IStore} from "../../store/IStore";
import {Dispatch} from "redux";
import {actions as paytableActions} from "../../reducers/paytableReducer";
import withWrapperConfiguration from "../wrapper/configuration/withWrapperConfiguration";
import {Button} from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";

interface IProps {
    [x: string]: any;

    // loader: {
    //     config: {string:string}
    // }
}

interface IStateToProps {

    //reel_data: any,
    // currentBetIndex: number,
    // autoplayCount: number,
    // betList: Array<number>

}

interface IDispatchToProps {
    // startSpin:any;
    // stopSpin:any;

}

interface IState {
    index: number,
    // isGameLoaded: boolean,
    // GameType: string,
    width: number | string,
    height: number | string,
    // pixelRatio: number,
    // lang: string

}

class Wrapper extends Component<IProps, IState> {
    protected app: PIXI.Application;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;

        this.state = {
            index: 0,
            width: this.props.width,
            height: this.props.height,
        }
    }

    render() {
        return (<div></div>)
    }

    // render_backup() {
    //     const {
    //         width, height
    //     } = this.state;
    //
    //     const WIDTH = this.props.width;  // Width of the viewport
    //     const HEIGHT = this.props.height;  // Width of the viewport
    //     const vpw = width as number;  // Width of the viewport
    //     const vph = height as number; // Height of the viewport
    //     let nvw; // New game width
    //     let nvh; // New game height
    //     let scaleRatio = 1;
    //
    //     if (vph / vpw < HEIGHT / WIDTH) {
    //
    //         nvh = vph;
    //         nvw = (nvh * WIDTH) / HEIGHT;
    //         scaleRatio = Math.min(
    //             nvw / WIDTH,
    //             nvh / HEIGHT
    //         );
    //     } else {
    //         // In the else case, the opposite is happening.
    //         nvw = vpw;
    //         nvh = (nvw * HEIGHT) / WIDTH;
    //         scaleRatio = Math.min(
    //             nvw / WIDTH,
    //             nvh / HEIGHT
    //         );
    //     }
    //     const {index} = this.state;
    //     if (!this.props.showPaytable) {
    //         return (<></>)
    //     }
    //     return (<div>
    //
    //
    //         <Button variant="warning" onClick={this.handleClick}
    //                 className="img-fluid"    style={{position: 'relative', top: '4%',zIndex:1,borderRadius: '50px',fontSize: '15px',fontWeight: 'bold',width:'30px',height:'30px',padding:'0px'}}>X</Button>{' '}
    //
    //         <Carousel activeIndex={index}
    //                   onSelect={this.handleSelect}
    //                   style={{
    //                       position: 'absolute', left: '50%', top: '50%',
    //
    //                       transform: "translate(-50%, -50%) " + "scale(" + scaleRatio + ")",
    //                   }}
    //         >
    //             <Carousel.Item style={{ zIndex:-1,}}>
    //                 <img
    //
    //                     src="../../assets/symbol/Diemond.png" width={1000} height={500}
    //                     alt="First slide"
    //                 />
    //                 <Carousel.Caption>
    //                     <h3>First slide label</h3>
    //                     <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
    //                 </Carousel.Caption>
    //             </Carousel.Item>
    //             <Carousel.Item style={{ zIndex:-1,}}>
    //                 <img
    //
    //                     src="../../assets/symbol/apple.png"
    //                     alt="Third slide" width={1000} height={500}
    //                 />
    //
    //                 <Carousel.Caption>
    //                     <h3>Second slide label</h3>
    //                     <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    //                 </Carousel.Caption>
    //             </Carousel.Item>
    //             <Carousel.Item style={{ zIndex:-1,}}>
    //                 <img
    //
    //                     src="../../assets/symbol/Banana.png" width={1000} height={500}
    //                     alt="Third slide"
    //                 />
    //
    //                 <Carousel.Caption>
    //                     <h3>Third slide label</h3>
    //                     <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p>
    //                 </Carousel.Caption>
    //             </Carousel.Item>
    //         </Carousel>
    //     </div>)
    // }
}

export default withPixiApp(connect(
    (state: Pick<IStore, 'paytableState'>): IStateToProps =>
        ({
            // showPaytable: state.paytableState.showPaytable,
        }),
    (dispatch: Dispatch): IDispatchToProps => ({
        // hidePaytable: (): any => dispatch(paytableActions.hidePaytable()),
    }))(withWrapperConfiguration(Wrapper)));